var DummyAbortController = /*#__PURE__*/function () {
  function DummyAbortController() {
    this.signal = {
      addEventListener: function addEventListener() {}
    };
  }
  /* eslint-disable-next-line class-methods-use-this */


  var _proto = DummyAbortController.prototype;

  _proto.abort = function abort() {};

  return DummyAbortController;
}();

var getDefaultAbortController = function getDefaultAbortController() {
  return typeof AbortController === 'undefined' ? DummyAbortController : AbortController;
};

export var createDriver = function createDriver(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$AbortController = _ref.AbortController,
      AbortController = _ref$AbortController === void 0 ? getDefaultAbortController() : _ref$AbortController,
      _ref$processResponse = _ref.processResponse,
      processResponse = _ref$processResponse === void 0 ? function (response) {
    return {
      data: response
    };
  } : _ref$processResponse;

  return function (requestConfig) {
    /**
     * To implement abort for any JavaScript Promise
     * @see https://medium.com/@bramus/cancel-a-javascript-promise-with-abortcontroller-3540cbbda0a9
     */
    var abortSource = new AbortController();
    var responsePromise = new Promise(function (resolve, reject) {
      requestConfig.promise.then(function (response) {
        resolve(processResponse(response));
      })["catch"](reject);
      abortSource.signal.addEventListener('abort', function () {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject('REQUEST_ABORTED');
      });
    });

    responsePromise.cancel = function () {
      return abortSource.abort();
    };

    return responsePromise;
  };
};